<template>
  <div
    class="SubNavWrapper"
    :class="[{ active: isOpen }, style]"
    :aria-hidden="!isOpen"
    :inert="!isOpen"
  >
    <ul
      class="SubNav"
      role="list"
      :inert="!isOpen"
    >
      <li
        v-for="child in navigation"
        :key="child.id"
        class="list-item"
      >
        <UILinkComponent
          class="nav-child"
          :to="child?.url"
        >
          {{ child?.name }}
        </UILinkComponent>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import type { NavigationItem } from '@tc8l/nuxt-base'

  defineProps<{
    navigation: NavigationItem[]
    isOpen?: boolean
    style?: 'mobile' | 'desktop'
  }>()
</script>

<style scoped lang="scss">
  .SubNavWrapper {
    position: absolute;
    left: calc(-1 * var(--padding-lg));
    top: 100%;
    visibility: hidden;
    pointer-events: none;

    &.active {
      visibility: visible;
      pointer-events: auto;

      .SubNav {
        opacity: 1;
        transform: scale(1) translateY(0);
      }
    }

    &.mobile {
      position: relative;
      left: unset;
      top: unset;
      transform: unset;
      display: grid;
      grid-template-rows: 0fr;
      transition: grid-template-rows 0.4s var(--ease-fast-in-slow-out);
      visibility: visible;
      pointer-events: none;
      padding-top: 0;

      .SubNav {
        min-height: 0;
        overflow: hidden;
        border-radius: 0;
        box-shadow: none;
        padding: 0;
        background: transparent;
        transform: none;

        .list-item {
          .nav-child {
            white-space: unset;
            font-size: 2rem;
            font-weight: 500;
          }
        }
      }

      &.active {
        grid-template-rows: 1fr;
        pointer-events: auto;

        .SubNav {
          opacity: 1;
          transform: none;
        }
      }
    }
  }

  .SubNav {
    display: flex;
    flex-direction: column;
    background-color: $beige;
    padding: var(--padding-lg);
    transition: 0.5s all var(--ease-fast-in-slow-out);
    opacity: 0;
    border-radius: 0 0 0.8rem 0.8rem;
    z-index: 10;
    transform: scale(0.8) translateY(-4rem);
    gap: var(--margin-sm);

    .nav-child {
      white-space: nowrap;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    .list-item {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
